import React from 'react'
import OrderList from './OrderList'

function Finished({status}) {
  return (
    <OrderList status={status} />
  )
}

export default Finished